// test848
(848 && 0);
